import React from 'react';
import { ProjectData } from '../projectData';
import ProjectHeader from '../ProjectHeader';
import './MobileProject.css';

interface MobileProjectProps {
  project: ProjectData;
}

// URLが動画ファイルかどうかを判定
const isVideoUrl = (url: string): boolean => {
  const videoExtensions = ['.mp4', '.mov', '.avi', '.webm', '.mkv', '.m4v'];
  const urlLower = url.toLowerCase();
  return videoExtensions.some(ext => urlLower.includes(ext));
};

const MobileProject: React.FC<MobileProjectProps> = ({ project }) => {
  return (
    <div className="project-detail mobile-project">
      <ProjectHeader project={project} showAppStoreLink={true} />

      {/* 画像・動画ギャラリー */}
      <div className="project-gallery">
        {project.images?.map((mediaUrl: string, index: number) => (
          <div key={index} className="gallery-item">
            {isVideoUrl(mediaUrl) ? (
              <video
                autoPlay
                loop
                muted
                playsInline
                preload="metadata"
                className="gallery-video"
              >
                <source
                  src={mediaUrl}
                  type="video/mp4"
                />
                Your browser does not support the video tag.
              </video>
            ) : (
              <img
                src={mediaUrl}
                alt={`${project.title} ${index + 1}`}
                className="gallery-image"
                loading={index < 5 ? "eager" : "lazy"}
                decoding="async"
              />
            )}
          </div>
        ))}
      </div>

      {/* クレジット */}
      {project.credits && project.credits.length > 0 && (
        <div className="project-credits">
          <div className="credits-grid">
            {project.credits.map((credit, index) => (
              <div key={index} className="credit-item">
                <span className="credit-role">{credit.role}</span>
                <div className="credit-dots"></div>
                <span className="credit-name">{credit.name}</span>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default MobileProject;
